import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../../App/App';
import { ContentBodyContext } from '../MainContent';
import { WhatsappContext } from './Whatsapp';
import jwt from 'jwt-decode'
import axios from 'axios';
import swal from 'sweetalert';

function ChatHeaderStatus() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateWhatsApp, dispatchWhatsApp } = useContext(WhatsappContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    const handleChange = (event) => {
        if (event.target.value == 3) {
            getCategory();
        } else {
            stateContentBody.socket.emit('whatsapp-status', {
                id: jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id,
                token: localStorage.getItem('token-helpdesk-umy'),
                action: 'update',
                data: {
                    status_id: event.target.value,
                    chat_id: stateWhatsApp.active,
                    user: stateWhatsApp.chats.find(data => data.id == stateWhatsApp.active)
                }
            })
            dispatchWhatsApp({
                type: 'TRIGGER',
                trigger: { message: 'reload-status' }
            })
        }

    }

    const getCategory = () => {
        //get category
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get('/api/v1/helpdesk/whatsapp/categories', config)
            .then(res => {
                //save
                dispatchWhatsApp({
                    type: 'CHATCATEGORY',
                    chatcategory: {
                        category: res.data.category,
                        client: res.data.client
                    }
                })

                //open modal
                dispatchWhatsApp({
                    ...stateWhatsApp,
                    type: "MODALSTATUS",
                    modalstatus: {
                        status: true,
                    }
                })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }


    const [renderStatus, setrenderStatus] = useState(<div className="col-6 col align-self-end "></div>)
    useEffect(() => {
        if ((stateWhatsApp.active != null) && (stateWhatsApp.filter != 'admin' || stateWhatsApp.trigger == 'reload-status') && stateWhatsApp.chats.length > 0) {
            const status = stateWhatsApp.chats.find(chat => chat.id == stateWhatsApp.active).status
            const isSelected = (param) => {
                return (param == status) ? true : false
            }
            const isDisabled = (param) => {
                if (status == 4) {
                    return false
                } else if ((status == 2 && param == 4) || (status == 1 && param == 4)) {
                    return true
                } else if (status == 3 && param != 3) {
                    return false
                } else {
                    return false
                }
            }
            setrenderStatus(
                <div className="col-6 col align-self-end ">
                    <div className="row col-12  p-0 m-0">
                        <div className="form-group pl-4 pr-4 pt-1 m-0 col-auto">
                            <small className="mr-0 ml-0 sm-2"><b>Status</b></small>
                        </div>
                        <div className="form-group p-0 m-0 col-8" style={{ "width": "100%", float: 'right' }}>
                            <select className="form-control form-select ml-0 mr-sm-2" onChange={handleChange}>
                                <option key="4" selected={isSelected(4)} disabled={isDisabled(4)} value="4" >New Message</option>
                                <option key="1" selected={isSelected(1)} disabled={isDisabled(1)} value="1" >Process</option>
                                <option key="2" selected={isSelected(2)} disabled={isDisabled(2)} value="2" >Pending</option>
                                <option key="3" selected={isSelected(3)} disabled={isDisabled(3)} value="3" >Done</option>
                            </select >
                        </div>
                    </div>
                    <div className="row justify-content-center col-12 p-0 m-0">
                        <small className="col-auto" style={{ color: 'red', fontSize: '0.7em' }}>
                            *If your message is complete,assign status to "Done".
                        </small>
                    </div>
                </div>
            )
        } else {
            setrenderStatus(<div className="col-6 col align-self-end "></div>)
        }
    }, [stateWhatsApp.active, stateWhatsApp.trigger])


    return (renderStatus)
}

export default ChatHeaderStatus
